import React, { PropTypes } from 'react'
import { Relayout, RelayoutItem } from 'relayout'
import CSSModules from 'react-css-modules'

import BoxList from 'components/box-list'
import PerformanceListItem from 'components/performance-list-item'
import { getDate, getWeekDay, getTime } from 'utils/datetime'
import { getPartnerUrl } from 'utils/urls'
import { formatPriceDecimals } from 'utils/format'

import styles from './performance-list.css'

const PerformanceList = ({
  currencyCode,
  day,
  partnerId,
  performances,
  soldTickets,
  totalPartnerShare,
}) => (
  <div styleName="performance-list">

    <div styleName="header">
      <Relayout valign="bottom">
        <RelayoutItem sm="6">
          <div styleName="date">
            {getDate(day)}, {getWeekDay(day)}
          </div>
        </RelayoutItem>
        <RelayoutItem sm="3">
          <div styleName="tickets">
            Tickets sold{performances.length > 1 && `: ${soldTickets}`}
          </div>
        </RelayoutItem>
        <RelayoutItem sm="3">
          <div styleName="total-partner-share">
            Revenue{performances.length > 1 && `: ${formatPriceDecimals(totalPartnerShare, currencyCode)}`}
          </div>
        </RelayoutItem>
      </Relayout>
    </div>

    <BoxList
      items={performances.map((performance, index) => (
        <PerformanceListItem
          currencyCode={currencyCode}
          key={index}
          soldTickets={performance.soldTickets}
          ticketCount={performance.ticketCount}
          time={getTime(performance.startTime)}
          totalPartnerShare={performance.totalPartnerShare}
          type={performance.ticketType}
          url={getPartnerUrl(partnerId, `/performance/${performance.id}`)}
        />
      ))}
    />

  </div>
)

PerformanceList.propTypes = {
  currencyCode: PropTypes.string,
  day: PropTypes.any,
  partnerId: PropTypes.any,
  performances: PropTypes.array,
  soldTickets: PropTypes.any,
  totalPartnerShare: PropTypes.any,
}

export default CSSModules(PerformanceList, styles, { allowMultiple: true })



/** WEBPACK FOOTER **
 ** ./src/components/performance-list/performance-list.js
 **/